export class ManufacturingOrderFiles {
  constructor(
    public existingFilesAmount: number
  ) { }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/manufacturing-order-files.ts